module.exports = __webpack_public_path__ + "img/Steam.31dc22ad.svg";